import { render, staticRenderFns } from "./HelpDetails.vue?vue&type=template&id=a28649a6"
import script from "./HelpDetails.vue?vue&type=script&lang=js"
export * from "./HelpDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports